import cx from 'classnames';
import Path from "./Path.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Waves(_ref) {
  let {
    id,
    width,
    height,
    fill,
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeLinecap,
    shapeRendering,
    background,
    className
  } = _ref;
  return /*#__PURE__*/_jsx(Path, {
    className: cx('visx-pattern-wave', className),
    path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
    id: id,
    width: width,
    height: height,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    strokeLinecap: strokeLinecap,
    shapeRendering: shapeRendering,
    background: background
  });
}